import { useEffect, useState } from "react";

import { Anchor, Button } from "@newsela/angelou";

import {
  useSalesforceChatSupport,
  SALESFORCE_CHAT_END,
  SALESFORCE_CHAT_START,
} from "@/salesforceChatSupport";

const SupportLink = () => (
  <>
    &nbsp;
    <Anchor openInNewTab href="https://support.newsela.com/contact/">
      Contact Support
    </Anchor>
  </>
);

// Salesforce chat support. This allows users to talk to support when they have issues.
// The chat prompt is all loaded from a Salesforce supplied min.js file which needs to be loaded.
// Then, the security information is loaded by the initEmbeddedMessaging call.
export const SupportChat = () => {
  const { isChatReady, launchChat } = useSalesforceChatSupport();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <SupportLink />;
  }

  return (
    <div>
      Need more help?
      {isChatReady ? (
        <Button
          flavor={Button.flavors.tertiary}
          size={Button.sizes.sm}
          onClick={launchChat}
        >
          Chat with our support
        </Button>
      ) : (
        <SupportLink />
      )}
      <br />
      (M - F {SALESFORCE_CHAT_START}am to {SALESFORCE_CHAT_END - 12}pm ET)
    </div>
  );
};
